import { httpsCallable } from 'firebase/functions'
import { functions } from 'configs/firebase'

export const calculateCredit = httpsCallable(functions, 'borrow-calculateCredit')
